import React, { useState } from 'react'
import Cookies from 'universal-cookie'
import PosMenuMovil from './PosMenuMovil';
import PosMenuEscritorio from './PosMenuEscritorio';
import axios from 'axios';
import PeticionTraeDatos from '../../componentesAdmin/hooks/useTraeDatos';


const baseUrl = process.env.REACT_APP_BASE_URL
const api = process.env.REACT_APP_API
const urlConfiguraciones = baseUrl + api + 'configuraciones/'

const PosMenu = (props) => {
    const [configuraciones] = PeticionTraeDatos(urlConfiguraciones)
    const dataConfiguracion = configuraciones ? configuraciones[16] : [];
    const alerta = dataConfiguracion ? JSON.parse(dataConfiguracion.valor) : []

    const { productos } = props;
    const Estado = () => {
        let colorNotificacion = ''
        let textoNotificacion = ''

        if (productos.length > 0) {

            let Agota = alerta[0] // tiene rangofin
            let PocasExis = alerta[1]
            let EnExis = alerta[2] //tiene rangoini

            let sumarInventario = 0

            productos.map(pro => {
                if (Boolean(pro.inventario) && parseInt(pro.inventarioCantidad) > 0) {
                    if (sumarInventario === 0) {
                        sumarInventario = parseInt(pro.inventarioCantidad)
                    }

                    if (sumarInventario != 0 && sumarInventario >= parseInt(pro.inventarioCantidad)) {
                        sumarInventario = parseInt(pro.inventarioCantidad)
                    }
                }
            })

            if (sumarInventario < parseInt(Agota?.rangofin)) {
                textoNotificacion = 'Agotado'
                colorNotificacion = 'Rojo'
            } else if (sumarInventario >= parseInt(PocasExis?.rangoini) && sumarInventario <= parseInt(PocasExis?.rangofin)) {
                textoNotificacion = 'Pocas Existencias'
                colorNotificacion = 'Amarillo'
            } else if (sumarInventario >= parseInt(EnExis?.rangoini)) {
                textoNotificacion = 'En Existencia'
                colorNotificacion = 'Verde'
            }
        }

        return {
            colorNotificacion,
            textoNotificacion
        }

    }


    const { colorNotificacion, textoNotificacion } = Estado()

    const cookies = new Cookies()

    const propsChildren = { ...props, cookies, colorNotificacion, textoNotificacion, Estado }
    return (
        <>
            <PosMenuMovil {...propsChildren} className="d-flex d-sm-flex d-md-none" />
            <PosMenuEscritorio  {...propsChildren} className="d-none d-sm-none d-md-flex" />
        </>

    )
}


export default PosMenu